import { z } from "zod";

/**
 * Schema for validating login form data.
 *
 * This schema ensures that both email and password fields:
 * - Are present in the form submission
 * - Have at least one character
 *
 * @remarks
 * This uses zod for validation and type inference.
 */
export const loginSchema = z.object({
  email: z.email().min(1).max(30),
  password: z.string().min(1).max(32),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
